import PageTitle from "@/components/PageTitle";
import SideBarWrapper from "@/components/SideBarWrapper";
import { Users } from "lucide-react";
import { Listing } from "./Listing";

const UserGroups = () => {
  return (
    <SideBarWrapper>
      <div className="LookUpTabs">
        <div className="content-lookups xl:p-5 p-3">
          <>
            <div>
              <div className="card mb-5 p-3">
                <PageTitle icon={Users} pageTitle="User Groups" />
              </div>
              <Listing />
            </div>
          </>
        </div>
      </div>
    </SideBarWrapper>
  );
};

export default UserGroups;
